export const truncateFirstName = (fullName: string | null, maxLength: number): string => {
  const first = fullName?.split(" ")[0] || "";
  return first.length > maxLength ? `${first.slice(0, maxLength)}...` : first;
};